import { ColumnType } from "antd/lib/table";
import { formatDateTime } from "ui/utils";

const columns: ColumnType<any>[] = [
  {
    title: "JOB",
    dataIndex: "jobId",
    align: "center",
    render: (value: string) => (
      <span style={{ fontWeight: "bold" }}>{value ?? "-"}</span>
    ),
  },
  {
    title: "PRÓXIMA EXECUÇÃO",
    dataIndex: "dataProximaExecucao",
    align: "center",
    render: (value: string) => (
      <span>{value ? formatDateTime(value) : "-"}</span>
    ),
  },
  {
    title: "ÚLTIMA EXECUÇÃO",
    dataIndex: "dataUltimaExecucao",
    align: "center",
    render: (value: string) => (
      <span>{value ? formatDateTime(value) : "-"}</span>
    ),
  },
  {
    title: "ÚLTIMO REGISTRO INSERIDO",
    dataIndex: "dataUltimoRegistroInserido",
    align: "center",
    render: (value: string) => (
      <span>{value ? formatDateTime(value) : "-"}</span>
    ),
  },
  {
    title: "PAUSADO",
    dataIndex: "pausado",
    align: "center",
    render: (value: string) => <span>{value ? "Sim" : "Não"}</span>,
  },
];

export default columns;
